import { media } from 'src/common/styles/breakpoints';
import styled, { css } from 'styled-components';

const FooterContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  gap: 2.5rem;

  ${media.w.min.px576(css`
    display: grid;
    grid-template-areas:
      'info contact '
      'links links '
      'annotation annotation ';
    grid-template-rows: auto;
  `)}

  ${media.w.min.px992(css`
    display: grid;
    grid-template-areas:
      'info links contact'
      'annotation annotation annotation';
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
  `)}
`;

export default FooterContentWrapper;
